<script>
import Spinner from "@/components/parts/Spinner.vue";
import ButtonComponent from "@/components/Button/ButtonComponent.vue";

export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "Modal",
    components: { Spinner, ButtonComponent },
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        newHeader: {
            type: Boolean,
            default: false,
        },
        headerOptions: {
            type: Object,
            default() {
                return {
                    title: "",
                    recurrence: "",
                    time: "",
                };
            },
        },
        title: {
            type: String,
            default: "",
        },
        submitText: {
            type: String,
            default: "",
        },
        closeText: {
            type: String,
            default: "",
        },
        modalDialogClass: {
            type: String,
            default: "",
        },
        submitBtnClass: {
            type: String,
            default: "",
        },
        closeBtnClass: {
            type: String,
            default: "",
        },
        defaultFooter: {
            type: Boolean,
            default: true,
        },
        simpleHeader: {
            type: Boolean,
            default: false,
        },
        showSpinner: {
            type: Boolean,
            default: false,
        },
        spinnerColor: {
            type: String,
            default: "white",
        },
        testIdSubmitBtn: {
            type: String,
            default: "modal-submt-btn",
        },
        removeModal: {
            type: Boolean,
            default: false,
        },
        showSubmitButton: {
            type: Boolean,
            default: true,
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["close-modal", "submit-modal", "submit-delete"],
    methods: {
        hideModal() {
            this.$emit("close-modal");
        },
        submitModal() {
            this.$emit("submit-modal");
        },
        submitDelete() {
            this.$emit("submit-delete");
        },
    },
};
</script>

<template>
    <div>
        <div
            class="modal"
            data-test="modal"
            :class="{ 'modal-open d-block': showModal }"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div
                class="modal-dialog"
                :class="{
                    [modalDialogClass]:
                        modalDialogClass !== '' &&
                        modalDialogClass !== undefined,
                    'modal-lg':
                        modalDialogClass === '' ||
                        modalDialogClass === undefined,
                }"
                role="document"
            >
                <div
                    class="modal-content"
                    data-test="modal-content"
                    :class="{ 'remove-modal': removeModal }"
                >
                    <div
                        v-if="!simpleHeader"
                        class="modal-header"
                        data-test="modal-header"
                        :class="{ 'grey-header': newHeader }"
                    >
                        <div v-if="newHeader">
                            <div class="modal-header_recurrence">
                                {{ headerOptions?.recurrence }}
                            </div>
                            <div
                                class="modal-header_title"
                                data-test="modal-header-title"
                            >
                                {{ headerOptions?.title }}
                            </div>
                            <div class="modal-header_time">
                                {{ headerOptions?.time }}
                            </div>
                        </div>
                        <div v-else class="modal-title" v-html="title"></div>
                        <button
                            type="button"
                            data-test="modal-btn-close"
                            class="close close-button"
                            :class="{
                                'd-flex flex-column align-self-center':
                                    newHeader,
                            }"
                            @click="hideModal"
                            aria-label="Close"
                        >
                            <span v-if="removeModal" class="" aria-hidden="true"
                            >&times;</span
                            >
                            <svg
                                v-if="!removeModal"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 0C5.38327 0 0 5.38327 0 12C0 18.6167 5.38327 24 12 24C18.6167 24 24 18.6167 24 12C24 5.38327 18.6167 0 12 0ZM16.3448 15.0398C16.4341 15.1247 16.5056 15.2266 16.5549 15.3395C16.6042 15.4524 16.6304 15.574 16.632 15.6972C16.6336 15.8204 16.6105 15.9427 16.5641 16.0568C16.5177 16.1709 16.4489 16.2746 16.3617 16.3617C16.2746 16.4489 16.1709 16.5177 16.0568 16.5641C15.9427 16.6105 15.8204 16.6336 15.6972 16.632C15.574 16.6304 15.4524 16.6042 15.3395 16.5549C15.2266 16.5056 15.1247 16.4341 15.0398 16.3448L12 13.3056L8.96019 16.3448C8.78567 16.5106 8.55329 16.6017 8.31259 16.5986C8.07188 16.5955 7.84191 16.4985 7.67169 16.3283C7.50147 16.1581 7.40448 15.9281 7.4014 15.6874C7.39832 15.4467 7.48939 15.2143 7.65519 15.0398L10.6944 12L7.65519 8.96019C7.48939 8.78567 7.39832 8.55329 7.4014 8.31259C7.40448 8.07188 7.50147 7.84191 7.67169 7.67169C7.84191 7.50147 8.07188 7.40448 8.31259 7.4014C8.55329 7.39832 8.78567 7.48939 8.96019 7.65519L12 10.6944L15.0398 7.65519C15.2143 7.48939 15.4467 7.39832 15.6874 7.4014C15.9281 7.40448 16.1581 7.50147 16.3283 7.67169C16.4985 7.84191 16.5955 8.07188 16.5986 8.31259C16.6017 8.55329 16.5106 8.78567 16.3448 8.96019L13.3056 12L16.3448 15.0398Z"
                                    fill="#FFB700"
                                />
                            </svg>
                        </button>
                    </div>
                    <div v-else class="simple-header">
                        <button
                            type="button"
                            class="close"
                            data-test="modal-btn-close"
                            :class="{
                                'd-flex flex-column align-self-center':
                                    newHeader,
                            }"
                            @click="hideModal"
                            aria-label="Close"
                        >
                            <!--                            <span aria-hidden="true">&times;</span>-->
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 0C5.38327 0 0 5.38327 0 12C0 18.6167 5.38327 24 12 24C18.6167 24 24 18.6167 24 12C24 5.38327 18.6167 0 12 0ZM16.3448 15.0398C16.4341 15.1247 16.5056 15.2266 16.5549 15.3395C16.6042 15.4524 16.6304 15.574 16.632 15.6972C16.6336 15.8204 16.6105 15.9427 16.5641 16.0568C16.5177 16.1709 16.4489 16.2746 16.3617 16.3617C16.2746 16.4489 16.1709 16.5177 16.0568 16.5641C15.9427 16.6105 15.8204 16.6336 15.6972 16.632C15.574 16.6304 15.4524 16.6042 15.3395 16.5549C15.2266 16.5056 15.1247 16.4341 15.0398 16.3448L12 13.3056L8.96019 16.3448C8.78567 16.5106 8.55329 16.6017 8.31259 16.5986C8.07188 16.5955 7.84191 16.4985 7.67169 16.3283C7.50147 16.1581 7.40448 15.9281 7.4014 15.6874C7.39832 15.4467 7.48939 15.2143 7.65519 15.0398L10.6944 12L7.65519 8.96019C7.48939 8.78567 7.39832 8.55329 7.4014 8.31259C7.40448 8.07188 7.50147 7.84191 7.67169 7.67169C7.84191 7.50147 8.07188 7.40448 8.31259 7.4014C8.55329 7.39832 8.78567 7.48939 8.96019 7.65519L12 10.6944L15.0398 7.65519C15.2143 7.48939 15.4467 7.39832 15.6874 7.4014C15.9281 7.40448 16.1581 7.50147 16.3283 7.67169C16.4985 7.84191 16.5955 8.07188 16.5986 8.31259C16.6017 8.55329 16.5106 8.78567 16.3448 8.96019L13.3056 12L16.3448 15.0398Z"
                                    fill="#FFB700"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body" data-test="modal-body">
                        <slot></slot>
                    </div>
                    <div
                        v-if="defaultFooter && !hideFooter"
                        class="modal-footer default"
                        data-test="modal-footer"
                    >
                        <a
                            @click="hideModal"
                            type="button"
                            class="link"
                            data-test="modal-footer-btn-close"
                            :class="[closeBtnClass]"
                        >{{ closeText || "Close" }}</a
                        >
                        <ButtonComponent
                            v-if="showSubmitButton"
                            @click="submitModal"
                            class="ml-auto"
                            dataTest="modal-footer-btn-submit"
                            :class="[submitBtnClass]"
                            :testId="testIdSubmitBtn"
                        >
                            {{ submitText || "Submit" }}
                            <Spinner :color="spinnerColor" v-if="showSpinner"/>
                        </ButtonComponent>
                    </div>
                    <div v-else-if="!hideFooter" class="modal-footer not-default">
                        <ButtonComponent
                            @click="submitDelete"
                            class="link"
                            type="outline"
                            dataTest="modal-footer-btn-close"
                            :class="{
                                'delete-button': closeBtnClass === '',
                                [closeBtnClass]: closeBtnClass !== '',
                            }"
                        >
                            {{ closeText || "Close" }}
                        </ButtonComponent>
                        <ButtonComponent
                            v-if="showSubmitButton"
                            @click="submitModal"
                            class="ml-auto"
                            dataTest="modal-footer-btn-submit"
                            :class="[submitBtnClass]"
                        >
                            {{ submitText || "Submit" }}
                            <Spinner :color="spinnerColor" v-if="showSpinner"/>
                        </ButtonComponent>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="modal-backdrop"
            :class="{ show: showModal, 'modal-backdrop-show': showModal }"
        ></div>
    </div>
</template>

<style scoped>
.btn-submit {
    font-weight: 600;
}

.btn-close {
    padding: 14px 24px;
    text-decoration: none;
}

.modal-backdrop {
    display: none;
}

.modal-backdrop-show {
    display: block !important;
}

.modal.modal-open .modal-dialog {
    z-index: 10;
}

.modal {
    overflow-x: hidden;
    overflow-y: auto;
}

.modal-content:not(.remove-modal) .close-button {
    position: absolute;
    right: 3rem;
}

.close-button {
    z-index: 3;
}

.modal-header_title {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 48px;
    color: #260045;
}

.modal-header_recurrence {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #999999;
}

.modal-header_time {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #636066;
}

.grey-header {
    background: rgba(221, 221, 221, 0.5);
    margin: -3rem -3rem 0;
    padding: 1.5rem 3rem !important;
}

.simple-header {
    cursor: pointer;
    position: absolute;
    top: 28px;
    right: 25px;
    z-index: 5;
}

.modal-content:not(.remove-modal) .modal-header {
    border-bottom: none;
}

.modal-content:not(.remove-modal) .modal-footer {
    border-top: none;
}

.modal-footer {
    margin-top: 3rem;
}

.modal-content {
    padding: 3rem;
}

.modal-header,
.modal-body,
.modal-footer {
    padding: unset;
}

.no-underline {
    text-decoration: none;
}

.regular-cancel {
    font-style: normal;
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 1.125rem;
    color: #260045;
}

.delete-button {
    background: #eb4247;
    border: 1px solid #eb4247;
    border-radius: 10px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #ffffff;
    text-decoration: none !important;
}

.close.close-button {
    opacity: 1;
}

.close.close-button:hover {
    opacity: 1;
}

.remove-modal {
    padding: 0;
}

.remove-modal .modal-header {
    padding: 12px 24px;
}

.remove-modal .modal-body {
    padding: 12px 24px;
}

.remove-modal .modal-footer {
    padding: 12px 24px;
}

.remove-modal .modal-title {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    color: #272529;
}

.remove-modal .link {
    color: #260045;
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 1.125rem;
    text-decoration: none;
}

@media only screen and (max-width: 768px) {
    .close.close-button {
        top: 23px
    }
}

/*.remove-modal .close.close-button {*/
/*    margin-left: 20px;*/
/*}*/
</style>
